import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const TelegramColoured = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm.432-12.495c-.895.372-2.685 1.143-5.37 2.313-.435.173-.664.343-.685.508-.035.28.316.391.794.541l.201.064c.47.153 1.103.332 1.432.339.298.007.63-.117.998-.369 2.508-1.693 3.803-2.549 3.885-2.567.057-.013.136-.03.19.018.054.048.049.139.043.163-.035.149-1.412 1.43-2.125 2.092-.222.207-.38.353-.412.386-.072.075-.146.146-.217.215-.437.42-.764.736.018 1.252.376.248.677.453.978.657.327.223.654.446 1.077.723.108.071.211.144.311.216.382.272.725.516 1.148.477.246-.022.5-.254.63-.944.304-1.63.904-5.164 1.043-6.62a1.63 1.63 0 0 0-.016-.362.388.388 0 0 0-.13-.25.606.606 0 0 0-.358-.107c-.346.006-.877.191-3.435 1.255Z"
        fill="#08C"
      />
    </Icon>
  );
};

export default TelegramColoured;
